import axios from 'axios';
import { GET_USERS, ADD_USER, EDIT_USER, EDIT_USER_PASSWORD, EDIT_PRIVILEGES, DELETE_USER, USERS_LOADING, GET_SPECIFIC_USER, CLEAR_USERS } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IUser } from '../../types/interfaces';
import store from '../store';

export const getUsers = () => (dispatch: Function, getState: Function) => {
  dispatch({
    type: USERS_LOADING
  });
  axios
    .get('/api/users', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_USERS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getUsersByPrivilegePromise = async (privilegeId: number): Promise<any[]> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/users/byPrivilege', {...tokenConfig(store.getState), params: {privilegeId}})
    .then(res =>
      resolve(res?.data)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const getUserById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: USERS_LOADING
  });
  axios
    .get('/api/users/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_USER,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getUsersWhoWorksAt = async (projectId: number) : Promise<IUser[]> => {
  return new Promise((resolve) => {
  axios
    .get('/api/users/worksAt', {...tokenConfig(store.getState), params: {projectId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => 
      console.log("err getUsersWhoWorksAt", err)
    );
  });
};

export const getPendingRequests = async () : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/users/pendingRequests', {...tokenConfig(store.getState), params: {}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getPendingRequests", err)
    });
  });
};

export const addUser = (user: IUser, societes: any[], worksAtSocietes: any[], underlings: any[], callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/users', {user, societes, worksAtSocietes, underlings}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_USER,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
        callback(false)
    });
};

export const editUser = (user: IUser, societes: any[], worksAtSocietes: any[], underlings: any[], callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/users/edit', {user, societes, worksAtSocietes, underlings}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_USER,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editUserPassword = (id: number, newPassword: string, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/users/newPassword', {id, newPassword}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_USER_PASSWORD,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editUserPrivileges = (id: number, privileges: any[], doneBy: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/users/privileges', {id, privileges, doneBy}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_PRIVILEGES,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteUser = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/users/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_USER,
        payload: id
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const clearUsers = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_USERS
  })
};